import { render, staticRenderFns } from "./TablePaginationRange.vue?vue&type=template&id=a2cbe420&scoped=true"
import script from "./TablePaginationRange.vue?vue&type=script&lang=js"
export * from "./TablePaginationRange.vue?vue&type=script&lang=js"
import style0 from "./TablePaginationRange.vue?vue&type=style&index=0&id=a2cbe420&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2cbe420",
  null
  
)

export default component.exports